<div class="trip-audit-dialog">
  <div class="trip-audit-dialog-header">
    <span class="trip-audit-dialog-title">Trip Code - {{ tripCode }}</span>
    <mat-icon class="trip-audit-dialog-close" (click)="onClickCancel()">clear</mat-icon>
  </div>

  <mat-divider></mat-divider>

  <div class="trip-audit-dialog-body">
    <div *ngIf="rows.length === 0" class="trip-audit-empty">
      --No Data Found--
    </div>

    <div *ngIf="rows.length > 0" class="trip-audit-results">
      <div class="trip-audit-results-toolbar">
        <span class="trip-audit-results-title">Audit Results</span>
        <span class="trip-audit-results-count">{{ rows.length }} record(s) found</span>
      </div>

      <div class="table-responsive trip-audit-table-wrapper">
        <table class="table table-borderless customTableTripAudit">
          <thead>
            <tr>
              <th class="col-added-updated-on">Added/Updated On</th>
              <th class="col-description">Description</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of rows" class="trip-audit-row">
              <td class="col-added-updated-on">{{ item.addedUpdatedOn || 'NA' }}</td>
              <td class="col-description" [matTooltip]="item.description">{{ item.description || 'NA' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
